import classNames from 'classnames';
import React from 'react';

import * as styles from './FeatureItem.module.scss';

export const FeatureItem: React.FC<{ text: string; icon: string }> = ({
	text,
	icon,
}) => {
	return (
		<div className={classNames(styles.container, 'd-flex align-items-center')}>
			<div className={styles.imageWrapper}>
				<img src={icon} alt={text.substring(0, 10)} loading="lazy" />
			</div>
			<div className={styles.textWrapper}>
				<p>{text}</p>
			</div>
		</div>
	);
};
